import { render } from "./AspspsList.vue?vue&type=template&id=56f60620&scoped=true"
import script from "./AspspsList.vue?vue&type=script&lang=js"
export * from "./AspspsList.vue?vue&type=script&lang=js"

import "./AspspsList.vue?vue&type=style&index=0&id=56f60620&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56f60620"]])

export default __exports__